import { render, staticRenderFns } from "./PackageQueueCard.vue?vue&type=template&id=8aeb995c&scoped=true&"
import script from "./PackageQueueCard.vue?vue&type=script&lang=ts&"
export * from "./PackageQueueCard.vue?vue&type=script&lang=ts&"
import style0 from "./PackageQueueCard.vue?vue&type=style&index=0&id=8aeb995c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeb995c",
  null
  
)

export default component.exports